import(/* webpackMode: "eager" */ "/var/www/vhosts/avagyanphoto.com/httpdocs/frontend/src/app/[lang]/template.js");
